import React from 'react'
import styled from 'styled-components'

export const Card = styled.button`
	width: 100%;
	max-width: 345px;
	background: ${props => props.theme.colors.brand.white};
	border: 1px solid ${props => props.theme.colors.greys.dividerGray};
	border-radius: 12px;
	padding: 32px 24px;
	display: flex;
	flex-direction: column;
	align-items: center;
	gap: 4px;
	cursor: pointer;
	transition: all 0.2s;
	flex: 1;

	@media (max-width: ${props => props.theme.sizes.breakPoints.small}) {
		background: transparent;
		border: 0px;
		padding: 0px 0px;
		gap: 10px;
	}
`

export const IconWrapper = styled.div`
	width: ${({ size }) => size || '64px'};
	height: ${({ size }) => size || '64px'};
	display: flex;
	align-items: center;
	justify-content: center;
	border-radius: 12px;
	@media (max-width: ${props => props.theme.sizes.breakPoints.small}) {
		background: ${props => props.theme.colors.brand.white};
		border: 1px solid ${props => props.theme.colors.greys.dividerGray};
		width: 100%;
		max-width: 190px;
		height: 64px;
	}
`

export const CardTitle = styled.span`
	font-size: 16px;
	font-weight: 500;
	color: ${props => props.theme.colors.text.primaryText};
	text-align: center;

	@media (max-width: ${props => props.theme.sizes.breakPoints.small}) {
		font-size: 14px;
	}
`

export const AccessIcon = styled.div`
	width: 24px;
	height: 24px;
	display: flex;
	align-items: center;
	justify-content: center;
	border-radius: 12px;
`

export const AccessGrid = styled.div`
	display: flex;
	flex-direction: row;
	gap: 16px;

	@media (max-width: ${props => props.theme.sizes.breakPoints.small}) {
	display: grid;
		grid-template-columns: repeat(2, 1fr);
	}
`
